import React, { useState } from "react";
import { Row, Col, Input, Button } from "antd";
import PriceCard from "./PriceCard";
import api from "libs/api";
import { contentAreaStyle, outerCardStyle } from "./CommonCard";

const CouponScreen = ({ selectedPackages, selectedSessions, selectedAddOns,setCouponCode:setParentCouponCode }) => {
  const [couponCode, setCouponCode] = useState("");
  const [couponValid, setCouponValid] = useState(false);
  const [couponMessage, setCouponMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);


  const validateCoupon = (code) => {
    // Placeholder for actual coupon validation logic
    if(code){
      setIsLoading(true);
      setCouponValid(false);
      api.get(`api/discounts/coupon/validate?code=${code}`).then(([success, response]) => {
        if (success) {
          setIsLoading(false);
          setCouponValid(true);
          setCouponMessage(`Coupon ${code} is valid`);
          setParentCouponCode(code);
          // Handle successful coupon validation
        } else {
          setIsLoading(false);
          console.error("Failed to validate coupon:", response);
          setCouponValid(false);
          setCouponMessage(`Coupon ${code} is invalid or not applicable`);
          setParentCouponCode("");
          // Handle failed coupon validation
        }
      }
      ).catch((error) => {
        setIsLoading(false);
        setCouponValid(false);
        setCouponMessage(`Error validating coupon: ${error.message}`);
        console.error("Error validating coupon:", error);
        // Handle error
      });
    }
  }


  return (
    <div style={outerCardStyle}>
      <div style={contentAreaStyle}>
      <Row gutter={[16, 16]} align="top" style={{ flex: 1 }}>
        {/* Left Section */}
        <Col xs={24} lg={18} style={{textAlign: "left"}}>
          <div style={{ marginBottom: 8 }}>
            Enter discount coupon code if you have any
          </div>

          <div style={{ fontWeight: "bold", marginBottom: 4 }}>Coupon Code</div>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={16}>
              <Input
                value={couponCode}
                onChange={(e) => {setCouponCode(e.target.value), setCouponValid(false), setCouponMessage("")}}
                placeholder="Enter coupon code"
              />
            </Col>
            <Col xs={24} sm={6} md={6} xl={4}>
              <Button
                type="primary"
                block
                loading={isLoading}
                onClick={() => validateCoupon(couponCode)}
                style={{
                  background: "#c62828",
                  border: "none",
                  borderRadius: 4,
                  minWidth: '80px'
                }}
              >
                Apply
              </Button>
            </Col>
          </Row>

          <div style={{ color: "green", fontSize: 14, marginTop: 8 }}>

            {couponValid ? (
              <span>{couponMessage}</span>
            ) : (
              <span style={{ color: "red" }}>{couponMessage}</span>
            )}
          </div>
        </Col>
        </Row>
      </div>

           <div style={{  textAlign: 'left',alignSelf: 'flex-start', marginTop: 3 }}>
            <PriceCard
              packages={selectedPackages}
              sessions={selectedSessions}
              addons={selectedAddOns}
            />
          </div>
    </div>
  );
};

export default CouponScreen;
